import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import toast from "react-hot-toast";
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';
import axiosInstance from '../../axiosInstance';

const Page = () => {
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState({
    metaTitle: '',
    metaDescription: '',
    description: ''
  });
  const { slug } = useParams();
  const contentRef = useRef(null);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [resumeForm, setResumeForm] = useState({
    name: '',
    email: '',
    phone: '',
    city: '',
    address: '',
    position: '',
    message: '',
    cv: null
  });

  const [isSubmittingContact, setIsSubmittingContact] = useState(false);
  const [isSubmittingResume, setIsSubmittingResume] = useState(false);

  const getPage = async () => {
    setLoading(true);
    try {
      const { data } = await axiosInstance.get(`/admin/get-page/${slug}`);
      setPage(data.Mpage || {
        metaTitle: '',
        metaDescription: '',
        description: ''
      });
    } catch (error) {
      console.log(error);
      toast.error("Error fetching page!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPage();
    window.scrollTo(0, 0);
  }, [slug]);

 
  const handleDynamicFormSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;

    // 👇 Find submit button and disable it
    const submitBtn = form.querySelector('button[type="submit"], button:not([type])');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = `
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Sending...
      `;
    }

    const formData = {};
    Array.from(form.elements).forEach(el => {
      if (el.name) {
        formData[el.name] = el.value;
      }
    });

    const payload = {
      name:    formData.name    || formData['full-name'] || '',
      email:   formData.email   || '',
      phone:   formData.phone   || '',
      message: formData.requirement || formData.message || '',
    };

    try {
      await axiosInstance.post('/contact-enquire', payload);
      toast.success('Enquiry sent successfully!');
      form.reset();
    } catch (error) {
      console.error('Failed to send enquiry:', error);
      toast.error('Failed to send enquiry');
    } finally {
      // 👇 Restore button after success or error
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = 'Submit Enquiry';
      }
    }
  };

  useEffect(() => {
    const container = contentRef.current;
    if (!container) return;

    container.addEventListener('submit', handleDynamicFormSubmit);
    return () => {
      container.removeEventListener('submit', handleDynamicFormSubmit);
    };
  }, [loading]);



  if (loading) {
    return (
      <>
        <Header />
        <div className="section" style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <p>Loading...</p>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <Helmet>
        <title>{page?.metaTitle}</title>
        <meta name="description" content={page?.metaDescription} />
      </Helmet>

      <div className="section" style={{ minHeight: '80vh' }}>
        <div className="container">
          <div dangerouslySetInnerHTML={{ __html: page?.description }} />
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Page;